import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Ui from './SelectedItem.styles';

const SelectedItem = ({ children, onRemove, onEdit }) => {
  const { t } = useTranslation('ownerPortal', { keyPrefix: 'pageModules' });

  const handleAction = (event, action) => {
    event.stopPropagation();
    action();
  };

  return (
    <Ui.Container>
      {(onRemove || onEdit) && (
        <Ui.ActionButtons>
          {onEdit && (
            <Ui.ActionButton
              type="button"
              aria-label={t('edit')}
              onMouseDown={(event) => handleAction(event, onEdit)}
            >
              <i className="bi bi-pencil" style={{ fontSize: 11 }} aria-hidden="true" />
            </Ui.ActionButton>
          )}
          {onRemove && (
            <Ui.ActionButton
              type="button"
              aria-label={t('remove')}
              onMouseDown={(event) => handleAction(event, onRemove)}
            >
              <i className="bi bi-x-lg" aria-hidden="true" />
            </Ui.ActionButton>
          )}
        </Ui.ActionButtons>
      )}
      {children}
    </Ui.Container>
  );
};

export default SelectedItem;
